import { RANK_LIST, CAREER_POINTS_RATIO } from '../constants/careerConfig';

/**
 * Calcula cuántos puntos de carrera genera una inversión.
 * Regla: Solo volumen real (no financiado).
 * 
 * @param {number} amount - Monto en USD
 * @param {boolean} isFinanced - Flag de la cuenta
 * @returns {number} Puntos generados
 */
export const calculateInvestmentPoints = (amount, isFinanced) => {
    if (isFinanced) return 0;
    return Math.floor(amount / CAREER_POINTS_RATIO);
};

/**
 * Determina si un usuario es elegible para subir de rango.
 * 
 * @param {number} accumulatedPoints - Puntos históricos del usuario
 * @param {number} currentRankId - ID del rango actual (0 si no tiene)
 * @param {object} structureData - Datos de equipo (vendedores, unidades, etc)
 * @returns {object|null} El nuevo rango alcanzado o null si no hay cambio
 */
export const evaluateRankEligibility = (accumulatedPoints, currentRankId, structureData = {}) => {
    // Buscamos el rango más alto que el usuario puede alcanzar con sus puntos
    const eligibleRank = [...RANK_LIST]
        .reverse()
        .find(rank => {
            const hasPoints = accumulatedPoints >= rank.pointsRequired;
            
            // Por ahora, para el Rango 1, solo validamos puntos. 
            // Para rangos superiores validaremos structureData.
            if (rank.id === 1) return hasPoints;
            
            // Placeholder para lógica de estructura en rangos superiores
            return hasPoints; 
        });

    // Solo devolvemos el rango si es superior al actual
    if (eligibleRank && eligibleRank.id > currentRankId) {
        return eligibleRank;
    }

    return null;
};

/**
 * Devuelve el color hexadecimal asociado a un ID de rango.
 * @param {number} rankId - ID del rango (1-8)
 * @returns {string} Color hexadecimal
 */
export const getRankColor = (rankId) => {
    const rank = RANK_LIST.find(r => r.id === rankId);
    return rank?.color || '#3dcc85'; // Verde Lignums por defecto
};

/**
 * Calcula cuántos puntos faltan para el siguiente rango.
 * @param {number} accumulatedPoints - Puntos actuales
 * @param {number} currentRankId - ID del rango actual
 * @returns {number|null} Puntos faltantes o null si es el rango máximo
 */
export const getRemainingPointsForNextRank = (accumulatedPoints, currentRankId) => {
    const nextRank = RANK_LIST.find(rank => rank.id > currentRankId);
    if (!nextRank) return null;
    return Math.max(nextRank.pointsRequired - accumulatedPoints, 0);
};